import React from "react";
import { Link } from "react-router-dom";

const ChildDropDown = ({ childrenList, toggle }) => {
    if (!childrenList) {
        return "";
    }

    if (typeof childrenList === "undefined" || !Array.isArray(childrenList)) {
        return "";
    }

    const children = childrenList.map((item, index) => {
        return (
            <li key={index}>
                <Link to={`/dashboard/child/${item.child_id}`}>
                    {item.name}
                </Link>
            </li>
        );
    });

    return (
        <ul
            className={
                toggle ? "child-dropdown-menu active" : "child-dropdown-menu"
            }
        >
            {children}
        </ul>
    );
};

export default ChildDropDown;
